import { Box, Flex, HStack, Skeleton, VStack } from '@chakra-ui/react'
import React from 'react'
import { Book } from './Book'
import { Title } from '../../../components/atoms/Title'
import { Button } from '../../../components/atoms/Button'
import { Link } from 'react-router-dom'
import { BookGrid } from './BookGrid'
import InfiniteScroll from 'react-infinite-scroll-component'

export function BookHStack({ title, books, subtitle = "", isLoading, onSelectBook, seeMoreLink, padding="10%" }) {

    if (isLoading || !books) return (
        <VStack align="flex-start" width="100%">
            <Title paddingLeft="5%" paddingBottom="20px">{title}</Title>
            <HStack paddingLeft="5%" gap={7} align="flex-start">
                {new Array(5).fill(0).map((_, i) => <VStack key={i}>
                    <Skeleton borderRadius="5px" width="200px" height="270px" />
                </VStack>)}
            </HStack>
        </VStack>
    )

    return (
        <VStack width="100%" spacing={4} alignContent="flex-start" padding={`0px ${padding}`}>
            <Title alignSelf="flex-start">{title}</Title>
            {subtitle !== '' && <Title fontSize={14} alignSelf="flex-start">{subtitle}</Title>}
            <Box width={'100%'} >
                <InfiniteScroll
                    dataLength={books} //This is important field to render the next data
                    style={{
                        overflow: "unset",
                        height: "100%",
                        paddingTop: "8px"
                    }}
                    next={() => {
                        if (isLoading) return;
                    }}
                    hasMore={false}
                    loader={
                        <BookGrid paddingTop="20px">
                            {new Array(4).fill(0).map((_, i) => (
                                <Skeleton key={i} borderRadius="5px" width="200px" height="270px" />
                            ))}
                        </BookGrid>
                    }
                    endMessage={<></>}
                >
                    <BookGrid>
                        {books.map(b => <Book onClick={() => onSelectBook(b)} {...b} />)}
                    </BookGrid>
                </InfiniteScroll>
            </Box>
            {seeMoreLink ? <Box width="100%" paddingLeft="5%"><Button fontSize="8pt" height="30px">
                <Link
                    style={{ textDecoration: "none!important" }}
                    to={{ pathname: seeMoreLink }}
                >
                    Veja todos {">>"}
                </Link>
            </Button></Box> : <></>}
        </VStack>
    )
}